import { Link } from "react-router-dom"
import AppInfo from "../../components/footer/AppInfo"
import React, { useEffect, useState } from "react"
import Loader from "../../components/loaders/Loader";

const NotFound: React.FC = () => {

    const [isLoading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if(isLoading)
            setTimeout(() => { setLoading(false) }, 1000)
    }, [isLoading])

    if(isLoading) return <Loader isLoading />

    return (
        <React.Fragment>
            <div className="card card-style p-4 text-center py-5">
                <p className="font-600 color-highlight mb-0">Error 404 - Page Not Found</p>
                <h1>Wooops! It's not Here!</h1>
                <p className="pb-4">
                    Sorry, the page you're looking for cannot be found. How about checking some of the other pages we have around?
                </p>
                <Link to="/" data-back-button className="btn btn-l btn-center-m font-700 gradient-highlight rounded-s mb-3">Back Home</Link>
            </div>
            <AppInfo />
        </React.Fragment>
    )
}

export default NotFound